import {
    LOGOUT,
    BSRS_LOGIN_REQUEST, 
    BSRS_LOGIN_SUCCESS,
    BSRS_LOGIN_FAILURE
} from '../../types'

import { clearBSRSToken, setBSRSToken, CORE_API_ENDPOINT ,clearToken} from 'Lib'
import { CALL_API } from 'Middlewares'

// export function authorizeO365(code){
//     return {
//         [CALL_API] : {
//             endpoint: `${CORE_API_ENDPOINT}/o365/token`,
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({ code }),
//             types: [
//                 O365_REGISTER_REQUEST,
//                 {
//                     type: O365_REGISTER_SUCCESS,
//                     payload(action, state, res){
//                         return res.json()
//                         .then(json => {
//                             const {
//                                 access_token,
//                                 expires_on,
//                                 refresh_token
//                             } = json

//                             const token = {
//                                 access_token,
//                                 expires_on,
//                                 refresh_token
//                             }

//                             setToken(token)
//                             return { token }
//                         })
//                     }
//                 },
//                 O365_REGISTER_FAILURE            
//             ]
//         }
//     }
// }

export function authorizeBSRS({email, password}){
    return {
        [CALL_API] : {
            endpoint: `${CORE_API_ENDPOINT}/user/verify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password }),
            types: [
                BSRS_LOGIN_REQUEST,
                {
                    type: BSRS_LOGIN_SUCCESS,
                    payload(action, state, res){
                        return res.json()
                        .then(json => {
                            const {
                                // user,
                                token: bsrsToken
                            } = json

                            setBSRSToken(bsrsToken)
                            return { bsrsToken }
                        })
                    }
                },
                BSRS_LOGIN_FAILURE            
            ]
        }
    }
}

export function logout(){
    clearBSRSToken()
    clearToken()
    return {
        type: LOGOUT
    }
}


// WEBPACK FOOTER //
// ./src/features/auth/actions.js